import React from "react";
import loadable from "@loadable/component";
import Loading from "../Loading.js";

const LoadableComponent = loadable(() => import("./EditMissingBeneficiary"), {
  fallback: <Loading />
});

const LoadableEditMissingBeneficiary = () => (
  <LoadableComponent />
)

export default LoadableEditMissingBeneficiary;
